import { defineMessages } from 'react-intl';

export default defineMessages({
    homeButton: {
        id: 'home.button',
        defaultMessage: 'Buy a gift card',
    },
    breadcrumbChoose: {
        id: 'breadcrumb.choose',
        defaultMessage: 'Choose type',
    },
    breadcrumbAmount: {
        id: 'breadcrumb.amount',
        defaultMessage: 'Amount',
    },
    breadcrumbExperience: {
        id: 'breadcrumb.experience',
        defaultMessage: 'Experience',
    },
    breadcrumbSender: {
        id: 'breadcrumb.sender',
        defaultMessage: 'Sender',
    },
    breadcrumbReview: {
        id: 'breadcrumb.review',
        defaultMessage: 'Review',
    },
    breadcrumbPayment: {
        id: 'breadcrumb.payment',
        defaultMessage: 'Payment',
    },
    chooseTitle: {
        id: 'choose.title',
        defaultMessage: 'Choose giftcard type',
    },
    chooseSubtitle: {
        id: 'choose.subtitle',
        defaultMessage: 'You can choose an amount or experience',
    },
    chooseTypeAmount: {
        id: 'choose.type.amount',
        defaultMessage: 'Give an amount gift card',
    },
    chooseTypeAmountDescription: {
        id: 'choose.type.amount.description',
        defaultMessage:
            'A amount gift card will allow your loved ones to decide later on which experience or dish they prefer',
    },
    chooseTypeExperience: {
        id: 'choose.type.experience',
        defaultMessage: 'Give an experience gift card',
    },
    chooseTypeExperienceDescription: {
        id: 'choose.type.experience.description',
        defaultMessage:
            'An experience will allow you to gift your loved ones with a lasting memory experience',
    },
    genericLabelAddToBag: {
        id: 'generic.label.add.to.bag',
        defaultMessage: 'Add to bag',
    },
    genericLabelUpdate: {
        id: 'generic.label.update',
        defaultMessage: 'Update',
    },
    genericLabelExperience: {
        id: 'generic.label.experience',
        defaultMessage: 'Experience',
    },
    genericLabelValue: {
        id: 'generic.label.value',
        defaultMessage: 'Value',
    },
    genericLabelWait: {
        id: 'generic.label.wait',
        defaultMessage: 'Wait',
    },
    genericLabelRecipient: {
        id: 'generic.label.recipient',
        defaultMessage: 'recipient',
    },
    genericLabelRecipients: {
        id: 'generic.label.recipients',
        defaultMessage: 'recipients',
    },
    genericLabelAmount: {
        id: 'generic.label.amount',
        defaultMessage: 'Amount',
    },
    genericLabelName: {
        id: 'generic.label.name',
        defaultMessage: 'Name',
    },
    genericLabelEmail: {
        id: 'generic.label.email',
        defaultMessage: 'Email',
    },
    genericLabelFirstName: {
        id: 'generic.label.first.name',
        defaultMessage: 'First Name',
    },
    genericLabelLastName: {
        id: 'generic.label.last.name',
        defaultMessage: 'Last Name',
    },
    genericLabelMessage: {
        id: 'generic.label.message',
        defaultMessage: 'Message',
    },
    genericMustMin: {
        id: 'generic.must.min',
        defaultMessage: 'must be min.',
    },
    genericAndMax: {
        id: 'generic.and.max',
        defaultMessage: 'and max.',
    },
    genericButtonContinue: {
        id: 'generic.button.continue',
        defaultMessage: 'Continue',
    },
    genericType: {
        id: 'generic.type',
        defaultMessage: 'Type',
    },
    genericCheckout: {
        id: 'generic.checkout',
        defaultMessage: 'Checkout',
    },
    genericBag: {
        id: 'generic.bag',
        defaultMessage: 'Bag',
    },
    genericAddedToBag: {
        id: 'generic.added.to.bag',
        defaultMessage: 'Added to bag',
    },
    genericUpdatedToBag: {
        id: 'generic.updated.to.bag',
        defaultMessage:
            'Remember to update your bag before checking out for the changes to be effective',
    },
    genericInformationMissing: {
        id: 'generic.information.missing',
        defaultMessage: 'Information missing',
    },
    genericRemove: {
        id: 'generic.remove',
        defaultMessage: 'remove',
    },
    genericMessageForReceiver: {
        id: 'generic.message.receiver',
        defaultMessage: 'Message for receiver',
    },
    genericLimit: {
        id: 'generic.limit',
        defaultMessage: 'You can purchase up to 50 gift cards per attempt.',
    },
    recipientLabel: {
        id: 'recipient.label',
        defaultMessage: 'Recipient',
    },
    recipientSendSameReceiver: {
        id: 'recipient.send.same.receiver',
        defaultMessage: 'Send gift cards to same receiver',
    },
    recipientApplyMessageAll: {
        id: 'recipient.apply.message.all',
        defaultMessage: 'Apply this message to all',
    },
    recipientMessagePlaceholder: {
        id: 'recipient.message.placeholder',
        defaultMessage: 'Type your message to the receiver here.',
    },
    senderTitle: {
        id: 'sender.title',
        defaultMessage: 'Senders Details',
    },
    senderDescription: {
        id: 'sender.description',
        defaultMessage: 'The invoice will be sent to this email',
    },
    paymentTitle: {
        id: 'payment.title',
        defaultMessage: 'Payment',
    },
    thankyouTitle: {
        id: 'thankyou.title',
        defaultMessage: 'Thank you',
    },
    thankyouDescription: {
        id: 'thankyou.description',
        defaultMessage: 'We have sent a receipt to the email ',
    },
    addAnotherGiftCard: {
        id: 'add.another.gift.card',
        defaultMessage: 'Add another amount gift card',
    },
    giveAmountTitle: {
        id: 'give.amount.title',
        defaultMessage: 'Give an amount gift card',
    },
    giveAmountDescription: {
        id: 'give.amount.description',
        defaultMessage:
            'A amount gift card will allow your loved ones to decide later on which experience or dish they prefer',
    },
    giveExperienceTitle: {
        id: 'give.experience.title',
        defaultMessage: 'Give an experience gift card',
    },
    giveExperienceDescription: {
        id: 'give.experience.description',
        defaultMessage:
            'An experience will allow you to gift your loved ones with a lasting memory experience',
    },
    reviewTitle: {
        id: 'review.title',
        defaultMessage: 'Review Gift Card',
    },
    reviewTermsOfUse: {
        id: 'review.terms',
        defaultMessage: 'I have read and understood the Terms of Use',
    },
    amountMustMin: {
        id: 'amount.must.min',
        defaultMessage: 'must be min.',
    },
    amountAndMax: {
        id: 'amount.and.max',
        defaultMessage: 'and max.',
    },
    errorRequired: {
        id: 'error.required',
        defaultMessage: 'This field is required',
    },
    errorGeneric: {
        id: 'error.generic',
        defaultMessage: 'Please try again',
    },
    errorInvalidAmount: {
        id: 'error.invalid.amount',
        defaultMessage: 'Insert a valid amount',
    },
    errorFirstname: {
        id: 'error.first.name',
        defaultMessage: 'The first name is required',
    },
    errorLastname: {
        id: 'error.last.name',
        defaultMessage: 'The last name is required',
    },
    errorEmail: {
        id: 'error.email',
        defaultMessage: 'The email is invalid',
    },
    adyenLabelCardNumber: {
        id: 'creditCard.label.cardNumber',
        defaultMessage: 'Credit Card',
    },
    adyenLabelExpiry: {
        id: 'creditCard.label.expiry',
        defaultMessage: 'MM/YY',
    },
    adyenLabelExpiryMonth: {
        id: 'creditCard.label.expiryMonth',
        defaultMessage: 'MM',
    },
    adyenLabelExpiryYear: {
        id: 'creditCard.label.expiryYear',
        defaultMessage: 'YY',
    },
    adyenLabelCvc: {
        id: 'creditCard.label.cvc',
        defaultMessage: 'CVV',
    },
    adyenLabelNameOnCard: {
        id: 'creditCard.label.nameOnCard',
        defaultMessage: "Card holder's name",
    },
    adyenButtonSave: {
        id: 'creditCard.button.save',
        defaultMessage: 'place order',
    },
    adyenErrorGeneric: {
        id: 'creditCard.error.generic',
        defaultMessage: 'There was a problem trying to save your credit card',
    },
    adyenErrorCardNumber: {
        id: 'creditCard.error.cardNumber',
        defaultMessage: 'Invalid credit card number',
    },
    adyenErrorCardExpiryDate: {
        id: 'creditCard.error.cardExpiryDate',
        defaultMessage: 'Invalid expiry date',
    },
    adyenErrorCardExpiryMonth: {
        id: 'creditCard.error.cardExpiryMonth',
        defaultMessage: 'Invalid expiry month',
    },
    adyenErrorCardExpiryYear: {
        id: 'creditCard.error.cardExpiryYear',
        defaultMessage: 'Invalid expiry year',
    },
    adyenErrorCardCvc: {
        id: 'creditCard.error.cardCvc',
        defaultMessage: 'Invalid CVV number',
    },
    adyenErrorCardHolder: {
        id: 'creditCard.error.cardHolder',
        defaultMessage: "Invalid card holder's name",
    },
});
